export const viewerRoutesNames = {
    EMPTY_URL: '',
};
